import React from 'react';
import { translate } from 'react-i18next';

// Services & Constants
import { currency } from 'services/currency';
import { getPayment, getLocalizeLabel, getSum } from 'services/payments';

// Styles
import styles from './styles';

// Images
import BlueTable from 'assets/images/table-blue.svg';
import PdfIcon from 'assets/images/pdf-icon.svg';

function getTotalSum(data) {
  if (data && Array.isArray(data)) {
    let sum = 0;
    data.forEach(table => {
      if (table && Array.isArray(table.items)) {
        table.items.forEach(item => {
          sum += item.general && typeof item.general === 'number' ? item.general : 0;
          sum += item.injections && typeof item.injections === 'number' ? item.injections : 0;
        });
      }
    });
    return sum;
  }
  return 0;
}

function getItemSum(item) {
  return getSum(item.items, 'general') + getSum(item.items, 'injections');
}

export default translate()(props => {
  const { data, onReportBtnClick, i18n } = props;

  return data && Array.isArray(data) && data.length ? (
    <styles.TIB_GeneralWrapper>
      {/* ──── Total ────────────────────────────────────────────────────────────────────────── */}
      <div className="total">
        <styles.TIB_Img>
          <img src={BlueTable} alt="table"/>
        </styles.TIB_Img>
        <styles.TIB_Sum>
          <span>{i18n.t('report_table_total')}</span>
          <span>{currency(getTotalSum(data) || 0).format()}</span>
        </styles.TIB_Sum>
      </div>

      {/* ──── Content ──────────────────────────────────────────────────────────────────────── */}
      {data.map(item => {
        const payment = getPayment(item.paymentMethod);
        return payment ? (
          <div key={`total-info-block-${item.paymentMethod}`}>
            <styles.TIB_Img>
              <img src={payment.activeIcon} alt="payment"/>
            </styles.TIB_Img>
            <styles.TIB_Sum>
              <span>{getLocalizeLabel(payment, ' / ')}</span>
              <span>{currency(getItemSum(item) || 0).format()}</span>
            </styles.TIB_Sum>
          </div>
        ) : null;
      })}

      {/* ──── Create report ───────────────────────────────────────────────────────────────── */}
      <div className="create-report">
        <button onClick={onReportBtnClick}>
          <img src={PdfIcon} alt="pdf"/>
          <span>{i18n.t('report_table_to_pdf_btn')}</span>
        </button>
      </div>
    </styles.TIB_GeneralWrapper>
  ) : null;
});
